import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ChildProvider } from '../context/ChildContext';
import ChildDashboard from '../components/ChildDashboard';
import IncomeSplit from '../components/viewsChild/IncomeSplit';
import ChildProfile from '../components/viewsChild/ChildProfileView.js';
import CurrencyComparison from '../components/viewsChild/CurrencyView/CurrencyComparison.js';

const ChildRoutes = () => (
  <ChildProvider>
    <Routes>
      <Route element={<ChildDashboard />}>
        <Route index element={<Navigate to="dashboard" replace />} />
        <Route path="dashboard" element={<ChildDashboard />} />
        <Route path="splits" element={<IncomeSplit />} />
        <Route path="profile" element={<ChildProfile />} />
        <Route path="currency-comparison" element={<CurrencyComparison />} />
      </Route>
    </Routes>
  </ChildProvider>
);

export default ChildRoutes;